import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultCategoryData, getCategoryById, updateCategory, createCategory } from '@/api/categories';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import FileUpload from '@/components/FileUpload/index.vue';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.parentId = 0;
    this.image = [];
    this.icon = [];
    this.isReadOnly = false;
    this.validateRequire = (rule, value, callback) => {
      if (value === '') {
        if (rule.field === 'imageURL') {
          this.$message({
            message: 'Upload cover image is required',
            type: 'error'
          });
        } else {
          this.$message({
            message: rule.field + ' is required',
            type: 'error'
          });
        }
        callback(new Error(rule.field + ' is required'));
      } else {
        callback();
      }
    };
    this.formData = Object.assign({}, defaultCategoryData);
    this.loading = false;
    this.rangeId = 0;
    this.rules = {
      name: [{
        required: true,
        message: 'Please enter name',
        trigger: 'blur'
      }, {
        min: 3,
        max: 150,
        message: 'Length should be 3 to 150',
        trigger: 'blur'
      }],
      email: [{
        required: true,
        message: 'Please enter email',
        trigger: 'blur'
      }, {
        type: 'email',
        required: true,
        message: 'Please enter valid email',
        trigger: 'change'
      }],
      contactNumber: [{
        required: true,
        message: 'Please enter mobile number',
        trigger: 'blur'
      }, {
        min: 10,
        max: 15,
        message: 'Length should be 10 to 15',
        trigger: ['blur', 'change']
      }]
    };
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultCategoryData);
      this.parentId = parseInt(this.$route.params.parentId);
      this.rangeId = +this.$route.query.rangeId || 0;
      // get range from parent category
      if (this.parentId) {
        this.fetchParentById(this.parentId);
      }
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await getCategoryById(id);
      this.formData = data;
      this.rangeId = data.rangeId;
      this.parentId = data.parentId;
      this.icon.push({
        name: data.name,
        url: data.icon
      });
      this.image.push({
        name: data.name,
        url: data.image
      });
      this.parentId = data.parent.id;
      // Just for test
      const title = this.formData.name;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async fetchParentById(id) {
    try {
      const data = await getCategoryById(id);
      this.rangeId = data.rangeId;
    } catch (err) {} // eslint-disable-line  no-empty
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  iconUploaded(file) {
    this.formData.icon = file.response;
  }
  imageUploaded(file) {
    this.formData.image = file.response;
  }
  async saveForm() {
    try {
      this.loading = true;
      // update range
      if (this.rangeId) {
        this.formData.range = {
          id: this.rangeId
        };
      }
      if (this.isEdit) {
        await updateCategory(this.formData.id, this.formData);
      } else {
        if (this.parentId) {
          this.formData.parent = this.parentId;
        }
        await createCategory(this.formData);
      }
      this.$notify({
        title: 'Success',
        message: 'Category saved',
        type: 'success',
        duration: 2000
      });
      this.loading = false;
      router.push('/category/list/' + this.parentId);
      // router.push('/category/list/' + this.parentId)
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'CategoryDetail',
  components: {
    FileUpload
  }
})], default_1);
export default default_1;